<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
	name: 'ToExport'
});
</script>
<template>
	<span :key="langKey" :flex="flex ? flex : null" class="to-export" :class="setClass">
		<to-button v-if="props.type === 'button'" ref="buttonEl" class="to-export-button" :disabled="props.disabled" icon="export" expand @click.stop="handleFloat(buttonEl)">{{ props.buttonText || t('to.export.button') }}</to-button>
		<to-icon v-else ref="iconEl" link class="to-export-icon" value="export" @click.stop="handleFloat(iconEl)"></to-icon>
		<to-float ref="floatEl" class="to-export-layer" width="30" lazy :before-open="props.beforeOpen" :before-close="props.beforeClose" @opened="props.opened" @closed="props.closed">
			<to-input v-model="_fileName" class="to-export-input">
				<template #prefix>
					<to-select v-model="_fileType" option-width="7" :clearable="false" class="to-export-select" :data="props.fileTypes"></to-select>
				</template>
				<to-button class="to-export-confirm" icon="ok" @click="handleExport">{{ t('to.export.confirm') }}</to-button>
			</to-input>
		</to-float>
	</span>
</template>
<script lang="ts" setup>
import { ToButton, ToIcon, ToFloat, ToInput, ToSelect } from '@touchvue/components'
import { ajax, AjaxOptions } from '@touchvue/utils'
import { ref, watch, computed } from 'vue'
import { t, langKey } from '@touchvue/locale'

export interface ExportProps {
	flex?: boolean
	mode?: string
	buttonText?: string
	type?: string
	fileTypes?: string
	fileType?: string
	fileName?: string
	action?: string
	headers?: object | null
	withCredentials?: boolean
	data?: object | null
	beforeStart?: () => boolean | Promise<boolean>
	httpRequest?: (option: AjaxOptions) => XMLHttpRequest
	inputProps?: object
	disabled?: boolean
	closed?: () => any
	beforeClose?: () => boolean | Promise<boolean>
	opened?: () => any
	beforeOpen?: () => boolean | Promise<boolean>
}
const props = withDefaults(defineProps<ExportProps>(), {
	flex: false,
	mode: 'default',
	buttonText: '',
	type: 'button',
	fileTypes: '.xlsx,.xls',
	fileType: '.xls',
	fileName: '',
	action: '',
	headers: () => null,
	withCredentials: false,
	data: () => null,
	beforeStart: () => true,
	httpRequest: ajax,
	inputProps: () => ({}),
	disabled: false,
	beforeOpen: () => true,
	opened: () => true,
	beforeClose: () => true,
	closed: () => true
})

const floatEl = ref(null)
const buttonEl = ref(null)
const iconEl = ref(null)
const _fileName = ref(props.fileName)
const _fileType = ref(props.fileType)
const btnIcon = ref('export|left')
const setClass = computed(() => {
	let arr: string[] = []
	if (props.mode) {
		arr.push(`mode-${props.mode}`)
	}
	return arr
})

const emit = defineEmits(['success', 'error', 'progress'])

watch(
	() => props.fileName,
	val => {
		_fileName.value = val
	}
)

watch(
	() => props.fileType,
	val => {
		_fileType.value = val
	}
)

const handleFloat = el => {
	if (props.disabled) {
		return
	}
	floatEl.value.toggle(el)
}

async function handleExport() {
	const fn = props.beforeStart()
	let flag = true
	if (fn && typeof (fn as any).then === 'function') {
		flag = await fn
	} else {
		flag = !!fn
	}
	if (!flag) {
		return false
	}
	btnIcon.value = 'loading|left'
	props.httpRequest({
		action: props.action,
		data: props.data || {},
		headers: props.headers,
		filename: _fileName.value,
		withCredentials: props.withCredentials,
		onError: err => {
			emit('error', err)
		},
		onSuccess: res => {
			const reader = new FileReader()
			reader.onload = () => {
				if ((window.navigator as any).msSaveOrOpenBlob) {
					try {
						const blobObject = new Blob([res])
						;(window.navigator as any).msSaveOrOpenBlob(blobObject, _fileName.value)
					} catch (e) {
						console.error('msSaveOrOpenBlob error:', e)
					}
					return
				}
				const url = window.URL.createObjectURL(new Blob([res]))
				const link = document.createElement('a')
				link.style.display = 'none'
				link.href = url
				link.setAttribute('download', _fileName.value + _fileType.value)
				document.body.appendChild(link)
				link.click()
			}
			reader.readAsText(res)
			btnIcon.value = 'export|left'
			emit('success', res)
		},
		onProgress: obj => {
			emit('progress', obj.percent, obj.loaded, obj.total)
		}
	})
}
</script>
